"use client";

import GhostExpandableText, {
  type GhostExpandableTextBreakpoint,
} from "./GhostExpandableText";

interface GhostGuideCardDescriptionProps {
  text: string;
  disableClampAt?: GhostExpandableTextBreakpoint;
}

export default function GhostGuideCardDescription({
  text,
  disableClampAt,
}: GhostGuideCardDescriptionProps) {
  return (
    <GhostExpandableText
      text={text}
      className="leading-6 lg:leading-7"
      disableClampAt={disableClampAt}
    />
  );
}
